import React from 'react';

import {
  BulkAssemblyConstructsStructuredTableMetadata,
  BulkAssemblyConstructsStructuredTableRowMetadata,
} from 'molbio/bulk-assembly/tables/BulkAssemblyConstructsStructuredTableAdapter';
import {
  BulkAssemblyFragmentsStructuredTableMetadata,
  BulkAssemblyFragmentsStructuredTableRowMetadata,
} from 'molbio/bulk-assembly/tables/BulkAssemblyFragmentsStructuredTableAdapter';
import makeCustomButtonActionFunction from 'notebook/structured-tables/action-functions/makeCustomButtonActionFunction';
import unsupportedOverflowMenuItem from 'notebook/structured-tables/action-functions/unsupportedOverflowMenuItem';
import {TableActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';
import Button, {ButtonStyle, ButtonSize} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

function renderDeleteActionFunction<
  TTableMetadata extends {
    isFiltered: boolean;
    onDeleteAll: () => void;
    onDeleteFiltered: () => void;
    onDeleteRange: (startIndex: number, endIndex: number) => void;
    tableRowsName: string;
  },
  TRowMetadata,
>({
  structuredTable,
  multiSelectionBox,
}: TableActionFunctionParameters<TTableMetadata, TRowMetadata>): JSX.Element {
  return (
    <Dropdown
      menu={
        <Menu width={MenuWidth.MEDIUM}>
          <Option
            onSelect={structuredTable.metadata.onDeleteAll}
          >{`Delete all ${structuredTable.metadata.tableRowsName}`}</Option>
          <Option
            isDisabled={!structuredTable.metadata.isFiltered}
            onSelect={structuredTable.metadata.onDeleteFiltered}
          >{`Delete filtered ${structuredTable.metadata.tableRowsName}`}</Option>
          <Option
            isDisabled={multiSelectionBox == null}
            onSelect={() => {
              structuredTable.metadata.onDeleteRange(multiSelectionBox!.minI, multiSelectionBox!.maxI);
            }}
          >
            {`Delete selected ${structuredTable.metadata.tableRowsName}`}
          </Option>
        </Menu>
      }
    >
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className="u-mini-spacing-left"
        icon="delete"
        isDropdown={true}
        size={ButtonSize.MINI}
      />
    </Dropdown>
  );
}

export const deleteConstructsActionFunction = makeCustomButtonActionFunction<
  BulkAssemblyConstructsStructuredTableMetadata,
  BulkAssemblyConstructsStructuredTableRowMetadata
>({
  getHidden: ({structuredTable}) => structuredTable.metadata.isReadOnly,
  renderToolbarButton: renderDeleteActionFunction,
  renderOverflowMenuItem: unsupportedOverflowMenuItem,
});

export const deleteFragmentsActionFunction = makeCustomButtonActionFunction<
  BulkAssemblyFragmentsStructuredTableMetadata,
  BulkAssemblyFragmentsStructuredTableRowMetadata
>({
  getHidden: ({structuredTable}) => structuredTable.metadata.isReadOnly,
  renderToolbarButton: renderDeleteActionFunction,
  renderOverflowMenuItem: unsupportedOverflowMenuItem,
});
